import { render } from "./variables.vue?vue&type=template&id=810377a8"
import script from "./variables.vue?vue&type=script&lang=js"
export * from "./variables.vue?vue&type=script&lang=js"

import "./variables.vue?vue&type=style&index=0&id=810377a8&lang=scss"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__